import React from 'react';

/**
 * Global error boundary. If any render error escapes (e.g. a translator-induced
 * DOM crash), show a friendly recovery screen instead of a blank white page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-boundary"
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            backgroundColor: '#fff',
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 12 }}>🍽️</div>
          <h1 style={{ color: '#004E64', fontSize: 22, fontWeight: 700, margin: '0 0 8px' }}>
            Algo correu mal
          </h1>
          <p style={{ color: '#9FA2B4', fontSize: 15, maxWidth: 360, margin: '0 0 20px' }}>
            Por favor recarregue a página. Se estiver a usar a tradução automática do
            navegador, experimente desativá-la para uma melhor experiência.
          </p>
          <button
            onClick={this.handleReload}
            data-testid="error-reload-button"
            style={{
              backgroundColor: '#FF6B35',
              color: '#fff',
              border: 'none',
              borderRadius: 9999,
              padding: '12px 28px',
              fontSize: 16,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
